import React, { useState } from 'react';
import ProfileCardsSection from '../components/ProfileCardsSection';
import QuickLinks from '../components/QuickLinks';
import { Helmet } from 'react-helmet-async';
import PostList from '../components/PostList';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';

// Fix for default marker icon issue with Leaflet and Webpack
delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
  iconRetinaUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon-2x.png',
  iconUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon.png',
  shadowUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-shadow.png',
});

const villagePosition = [28.3695246855255, 77.77608462141842]; // Position for Sikhera

// Tile Layers
const tileLayers = {
  street: {
    url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
    attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
  },
  satellite: {
    url: "https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}",
    attribution: 'Tiles &copy; Esri &mdash; Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community'
  }
};

const Home = () => {
  const [mapType, setMapType] = useState('street'); // 'street' or 'satellite'

  return (
    <div className="w-full">
      <Helmet>
        <title>Sainik Shiromani Sikhera - Digital Village</title>
        <meta name="description" content="Official portal for Sainik Shiromani Sikhera village. Connect with us, access digital services, and stay updated." />
      </Helmet>
      
      <section className="bg-blue-50 border-b border-blue-100 pt-4 md:pt-8 pb-10 md:pb-16">
          <div className="container mx-auto px-4 text-center">
              <h1 className="text-3xl md:text-5xl font-extrabold text-blue-900">सैनिक शिरोमणि सिखेड़ा</h1>
              <p className="mt-3 text-md md:text-lg text-blue-700 max-w-2xl mx-auto">A Digital Village connecting our past, present, and future. Welcome to our official portal.</p>
          </div>
      </section>

      <ProfileCardsSection />

      <div className="max-w-7xl mx-auto py-10 px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-10">
          
          <div className="lg:col-span-2 space-y-8">
              <div className="bg-white p-6 rounded-xl shadow-md border border-slate-200/80">
                  <h2 className="text-2xl font-bold text-slate-800 mb-4">About Our Village</h2>
                  <p className="text-slate-600 leading-relaxed">
                    Sikhera is a village of soldiers, farmers, and families. This portal is a window into our world, a place to connect, and a platform for progress. Explore our history, meet our people, and stay updated with the latest happenings. 
                  </p>
                  <a href="/history" className="text-blue-600 font-semibold hover:underline mt-4 inline-block">Learn more about our history &rarr;</a>
              </div>
              
              <div className="bg-transparent">
                  <h2 className="text-2xl font-bold text-slate-800 mb-4">Latest Posts</h2>
                  <PostList />
              </div>
          </div>

          <div className="space-y-8">
              <QuickLinks />

              <div className="bg-white p-6 rounded-xl shadow-md border border-slate-200/80" style={{ position: 'relative', zIndex: 0 }}>
                  <h2 className="text-xl font-semibold mb-4 text-slate-800">Village Map</h2>
                  <div className="aspect-w-16 aspect-h-9 rounded-lg overflow-hidden border-2 border-slate-200" style={{ height: '350px' }}>
                    <MapContainer center={villagePosition} zoom={13} scrollWheelZoom={true} className="h-full w-full">
                      <TileLayer
                        url={tileLayers[mapType].url}
                        attribution={tileLayers[mapType].attribution}
                      />
                      <Marker position={villagePosition}>
                        <Popup>
                          <b>Sainik Shiromani Sikhera</b><br />
                          Panchayat: Sikhera<br />
                          Block: Loni
                        </Popup>
                      </Marker>
                    </MapContainer>
                  </div>
                  <div className="mt-4 flex justify-center space-x-2">
                      <button onClick={() => setMapType('street')} className={`px-4 py-2 text-sm font-semibold rounded-lg ${mapType === 'street' ? 'bg-blue-600 text-white' : 'bg-slate-200 text-slate-700'}`}>Street View</button>
                      <button onClick={() => setMapType('satellite')} className={`px-4 py-2 text-sm font-semibold rounded-lg ${mapType === 'satellite' ? 'bg-blue-600 text-white' : 'bg-slate-200 text-slate-700'}`}>Satellite View</button>
                  </div>
              </div>
          </div>

        </div>
      </div>
    </div>
  );
}

export default Home;
